import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/store/Navbar";
import { Footer } from "@/components/store/Footer";
import { CartDrawer } from "@/components/store/CartDrawer";
import { WhatsAppFab } from "@/components/store/WhatsAppFab";
import { CookieConsent } from "@/components/store/CookieConsent";
import { SmoothScroll } from "@/components/store/SmoothScroll";

export const StoreLayout = () => (
  <SmoothScroll>
    <div className="bg-bone min-h-screen flex flex-col">
      <Navbar />
      <CartDrawer />
      <WhatsAppFab />
      <CookieConsent />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  </SmoothScroll>
);
